import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
import config from "@/config";
const title = config.title;

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: `/`, // 这个表示的是根目录，即一进入的页面
      redirect: "f_home" // 设置页面一进来就显示的页面
    },
    {
      path: "/f_home",
      name: "f_home",
      component: () => import("@/view/f_home/f_home"),
      hidden: true
    },
    {
      path: "/h_product",
      name: "产品列表", //产品
      component: () => import("@/view/h_product/h_product"),
      hidden: true
    },
    ,
    {
      path: "/f_TECH",
      name: "f_TECH", //技术
      component: () => import("@/view/f_TECH/f_TECH"),
      hidden: true
    },
    {
      path: "/f_FAQ",
      name: "f_FAQ", //问答
      component: () => import("@/view/f_FAQ/f_FAQ"),
      hidden: true
    },
    {
      path: "/h_newslist",
      name: "新闻列表",
      component: () => import("@/view/h_newslist/h_newslist"),
      hidden: true
    },
    {
      path: "/f_aboutUs",
      name: "f_aboutUs", //关于我们
      component: () => import("@/view/f_aboutUs/f_aboutUs"),
      hidden: true
    },
    {
      path: "/h_contactUs",
      name: "h_contactUs", //联系我们
      component: () => import("@/view/h_contactUs/h_contactUs"),
      hidden: true
    },
    {
      path: "/ipList",
      name: "ipList", //访问记录
      component: () => import("@/view/ipList"),
      hidden: true
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js